import { render, staticRenderFns } from "./ModulesListContainer.vue?vue&type=template&id=2fa32ad2&"
import script from "./ModulesListContainer.vue?vue&type=script&lang=js&"
export * from "./ModulesListContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModulesListContainer.vue?vue&type=style&index=0&id=2fa32ad2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports